/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const GroupsEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('GROUPS_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class GroupsEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return GroupsEnabledSettingParser.decode(input).map(res => new GroupsEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return GroupsEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return GroupsEnabledSettingParser.encode(data);
    }
    static schema() {
        return GroupsEnabledSettingParser.schema();
    }
}
